export default "__VITE_ASSET__C3w6w8OG__"